import { Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { ISystemActionParam } from 'src/app/domain/registration/models/ISystemActionParam';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { UserService } from '../../users/crud.service';
import {
  COLUMNS_TO_SHOW_MOBILE,
  TABLE_CONFIG_COLUMNS
} from '../crud-config';
import { SystemActionParamService } from '../crud-service';
import { SystemActionCategoryTypeEnum, SystemActionCategoryTypeIdEnum, getSystemActionCategoryTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-action-category-type.enum';
import { take } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
  selector: 'app-system-action-param-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemActionParamService],
})
export class SystemActionParamCrudIndex
  extends AbstractCrudIndex<ISystemActionParam>
  implements ITableResponsive
{
  override configColumns = TABLE_CONFIG_COLUMNS;
  override COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_MOBILE;
  override COLUMNS_TO_SHOW_WEB = COLUMNS_TO_SHOW_MOBILE;

  editParams = [
    'type',
    'systemActionCategory',
    'systemAction',
    'systemActionParam'
  ];
  public filterFormValues: any = null
  constructor(
    public override dialog: MatDialog,
    public override service: SystemActionParamService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public usersService: UserService,
    public override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    this.title = service.pluralTitle.toUpperCase();
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? this.COLUMNS_TO_SHOW_MOBILE
        : this.COLUMNS_TO_SHOW_WEB;
    });
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe((dataWithPagination: any) => {
      const [data, length] = dataWithPagination;
      this.length = length;

      this.loadDatasource(data);
    });
  }

  private loadDatasource(data: any) {
    this.dataSource = new MatTableDataSource<any>(
      data.map((item: any) => {

      //   item['hideEdit'] = !item.allowEdit;
      //   item['hideDelete'] = !item.allowDelete;
        item.code = `${item.code}`.padStart(4, '0');
        item.systemActionCategoryType = getSystemActionCategoryTypeDescriptionByValue(item?.systemAction?.systemActionCategory?.type);
        item.systemAction = item?.systemAction?.name;
        return item;
      })
    );
  }

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.loadDatasource(data);
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.code) params.code = filter.code;
    else delete params.code;

    if (filter.systemActionCategoryType) params.systemActionCategoryType = SystemActionCategoryTypeIdEnum[filter.systemActionCategoryType];
    else delete params.systemActionCategoryType;

    if (filter.systemAction) params.systemAction = filter.systemAction.toUpperCase();
    else delete params.systemAction;

    if (filter.name) params.name = filter.name.toUpperCase()
    else delete params.name;

    return params;
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  _openEdit($event: any) {
    this.router.navigate(['system-action-params/edit', $event.id], {
      state: { editParams: this.editParams }
    });
  }

  _openNew($event: any) {
    this.router.navigate(['system-action-params/new']);
  }

  _openShow($event: any) {
    this.router.navigate(['system-action-params/show', $event.id]);
  }

  public resetFilter(): void {
    this.filterFormValues = null;
    localStorage.removeItem('parcllilterFormValues');

    this.isAdvancedFilterActive = false;
    this.lastAppliedFilter = null;
    this.params = { limit: 25, page: 0, filter: '' };

    const resetFields = this.filterFields.map(field => {
      if (field.type === TypeComponentFieldEnum.SLIDE_TOGGLE) {
        return { ...field, value: false };
      }
      return { ...field, value: '' };
    });

    this.filterFields = resetFields;

    this.loadList();
  }
}
